import { render, staticRenderFns } from "./CustomerPortfolioView.vue?vue&type=template&id=4fed6eb5&scoped=true"
import script from "./CustomerPortfolioView.vue?vue&type=script&lang=js"
export * from "./CustomerPortfolioView.vue?vue&type=script&lang=js"
import style0 from "./CustomerPortfolioView.vue?vue&type=style&index=0&id=4fed6eb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@6.26.3_css-loader@6.11.0_webpack_0adae5f353b25b49b54638f9fc4b63b8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fed6eb5",
  null
  
)

export default component.exports